<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="double-block-text">
    <div
      class="section-double-block-text row-270-25 p-top-l-1 p-bottom-l-1 max"
    >
      <!-- eslint-disable vue/no-v-html -->
      <div class="container">
        <div class="left title-base1" v-html="block.titolo" />
        <div class="right text-s-1-b" v-html="block.testo" />
      </div>
      <div
        v-if="block.immagineDecorativa"
        class="decoration-img-container on-text"
      >
        <DecorationImage
          :image="block.immagineDecorativa.immagine"
          :type="block.immagineDecorativa.titolo"
        />
      </div>
      <DefaultBtn
        v-if="block.cta?.file"
        :text="block.cta.testo"
        :content="block.cta.file.url"
        class="button-round-1 with-icon is-orange"
      />
      <DefaultLink
        v-if="block.cta?.link"
        class="button-round-1 with-icon text-custom is-semi-bold"
        :text="block.cta.testo"
        :content="block.cta.link"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoubleBlockText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
